module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bbQBm"))).then(() => parcelRequire('d0iPb'));